import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {
    mapCities: [],
    loading: true,
    reRender: false
};

const fetchMapCitiesStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchMapCitiesSuccess = ( state, action ) => {
    return updateObject( state, {
        mapCities: action.mapCities,
        loading: false,
        reRender: true
    } );
};

const fetchMapCitiesFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};



const updateMapCity = ( state, action ) => {
    return updateObject( state,{        
        mapCities: state.mapCities.map(mapCity => mapCity.City === action.City?
            
            { ...mapCity, 
                bags: action.bags,
                show: action.show                
            } : 
            mapCity
        )
    });
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_MAPCITIES_START: return fetchMapCitiesStart( state, action );
        case actionTypes.FETCH_MAPCITIES_SUCCESS: return fetchMapCitiesSuccess( state, action );
        case actionTypes.FETCH_MAPCITIES_FAIL: return fetchMapCitiesFail( state, action );
        case actionTypes.UPDATE_MAPCITY: return updateMapCity(state,action);
        default:
            return state;
    }
};



export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/mapCities.js